// src/App.jsx
import "./App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar/Navbar";
import ScrollToTopButton from "./components/ScrollToTopButton/ScrollToTopButton";
import Footer from "./components/Footer/Footer";

import Home from "./pages/Home/Home.jsx";
// import Aprende from "./pages/Aprende/Aprende.jsx";
import Becas from "./pages/Becas/Becas.jsx";
import ScholarshipDetail from "./components/ScholarshipDetail/ScholarshipDetail.jsx";
import FiltroBecas from "./components/FiltroBecas/FiltroBecas.jsx";
// import PostDetail from "./components/PostDetail/PostDetail.jsx";
import FacebookGroups from "./pages/FacebookGroups/FacebookGroups.jsx";
import QuienesSomos from "./pages/QuienesSomos/QuienesSomos.jsx";
import Faq from "./pages/Faq/Faq.jsx";
import Contact from "./pages/Contacto/Contacto.jsx";
// import CategoryPage from "./components/CategoryPage/CategoryPage.jsx";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy.jsx";
import TermsOfService from "./components/TermsOfService/TermsOfService.jsx";
import CoursesPage from "./pages/CoursesPage/CoursesPage.jsx";
import CourseDetailPage from "./components/CourseDetailPage/CourseDetailPage.jsx";
import ModuleDetailPage from "./components/ModuleDetailPage/ModuleDetailPage.jsx";
// import Tienda from "./components/Tienda/Tienda.jsx";
// import Producto from "./components/Tienda/Producto.jsx";
import NotFoundPage from "./pages/NotFoundPage/NotFoundPage.jsx";

function App() {
  /**
   * 📱 Detectar si viene desde la app
   * ?source=app
   */
  useEffect(() => {
    const isApp =
      new URLSearchParams(window.location.search).get("source") === "app";

    if (isApp) {
      document.body.classList.add("app");
    } else {
      document.body.classList.remove("app");
    }
  }, []);

  return (
    <BrowserRouter>
      <Navbar />

      <ScrollToTopButton />

      <Routes>
        <Route path="/" element={<Home />} />
        {/* <Route path="/guias" element={<Aprende />} />
        <Route path="/guias/:id" element={<PostDetail />} />
        <Route path="/category/:slug" element={<CategoryPage />} />*/}
        <Route path="/becas" element={<Becas />} />
        <Route path="/becas/:idx" element={<ScholarshipDetail />} />
        <Route path="/filtro-becas" element={<FiltroBecas />} />
        <Route path="/viviendas" element={<FacebookGroups />} />
        <Route path="/quienes-somos" element={<QuienesSomos />} />
        <Route path="/preguntas-frecuentes" element={<Faq />} />
        <Route path="/contacto" element={<Contact />} />
        <Route path="/politica-de-privacidad" element={<PrivacyPolicy />} />
        <Route path="/terminos-de-servicio" element={<TermsOfService />} />
        <Route path="/cursos" element={<CoursesPage />} />
        <Route path="/cursos/:id" element={<CourseDetailPage />} />
        {/* <<Route path="/herramientas" element={<Tienda />} />
        <Route path="/herramientas/:slug" element={<Producto />} /> */}
        <Route
          path="/cursos/:courseId/:moduleId"
          element={<ModuleDetailPage />}
        />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>

      <Footer />
    </BrowserRouter>
  );
}

export default App;
